import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";

import {ApplicationState} from "../../../store";
import {LayoutState} from "../../../store/layouts/types";
import {getLinearCoefs} from "../../../utils";
import './style.css';
import {setSpeedPlayback} from "../../../store/timeline/actions";
import {triggerSpeedPicker} from "../../../store/layouts/actions";
import CloseIconComponent from "../CloseIconComponent";

const { CONFIG } = window;


let startPos: number | null = null;
const height = 100;
let shift: number = height / 2;


const updateValueSpeed = (shift: number) => {
    const rate: number = shift / height;
    const { max, middle, min } = CONFIG.playbackSpeed;

    const { k, b } = rate < 0.5
        ? getLinearCoefs({x1: 0, y1: min}, {x2: 0.5, y2: middle})
        : getLinearCoefs({x1: 0.5, y1: middle}, {x2: 1, y2: max});

    const value = (rate * k + b);
    let val : string | string[] = rate < 0.5
        ? value.toFixed(1)
        : value.toFixed(0);

    const i = val.indexOf('0');
    if (i !== -1 && +val%10 !== 0) {
        val = val.split('');
        val = [...val.slice(0, i), ...val.slice(i + 1)];
        val = val.join('');
    }

    if (val === middle + '.') val = middle + '';

    const el = document.getElementById('speed-value');

    if (val.split('.')[1] === "") val = val.split('.')[0];

    if (el) el.innerText = val + 'x';

    return value > 1 ? +value.toFixed(0) : +value.toFixed(1)
};

const setPosPicker = (ref: React.RefObject<HTMLDivElement>, shift: number) => {
    const el = ref.current;
    if (el) {
        el.style.bottom = shift + 'px';
        el.style.display = 'block';
    }
};


const SpeedPickerComponent = () => {
    const ref = useRef<HTMLDivElement>(null);
    const { speedPickerIsOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const dispatch = useDispatch();

    useEffect(() => {
        if (speedPickerIsOpened) {
            setPosPicker(ref, shift);
        }
    }, [speedPickerIsOpened]);

    useEffect(() => {
        return () => {
            dispatch(triggerSpeedPicker(false));
            reload();
        }
    }, []);

    const onMouseDown = (e: React.MouseEvent) => {
        e.stopPropagation();
        startPos = e.clientY + shift;

        const el = ref.current;
        if (el) {
            el.style.opacity = '1';
        }

    };
    const onMouseMove = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (startPos === null) return;
        shift = startPos - e.clientY;
        shift = shift > height ? height : shift;
        shift = shift < 0 ? 0 : shift;

        const el = ref.current;
        if (el) {
            setPosPicker(ref, shift);
            updateValueSpeed(shift)
        }
    };
    const onMouseUp = (e: React.MouseEvent) => {
        startPos = null;
        e.stopPropagation();

        const el = ref.current;
        if (el) {
            el.style.opacity = '.7';
        }

        const speed = updateValueSpeed(shift);
        dispatch(setSpeedPlayback(speed))
    };

    const reload = () => {
        shift = height / 2;
        updateValueSpeed(shift);
        setPosPicker(ref, shift);
        dispatch(setSpeedPlayback(window.CONFIG.playbackSpeed.middle))
    };

    const close = () => dispatch(triggerSpeedPicker(false));

    return(
        <>
            {
                speedPickerIsOpened &&
                <div className={'speed-picker noselect'}>
                    <div className={'speed-picker-strip noselect'}>
                        <div className={'speed-picker-strip-runner pointer noselect'}
                             onMouseDown={onMouseDown}
                             onMouseMove={onMouseMove}
                             onMouseLeave={onMouseUp}
                             onMouseUp={onMouseUp}
                             ref={ref}
                        />
                    </div>
                    <div className={'reload-speed noselect'}
                         onClick={reload}
                    >
                        <span className='noselect' >
                            &#8661;
                        </span>
                    </div>
                    <CloseIconComponent handler={close}/>
                </div>
            }
        </>
    )
};

export default SpeedPickerComponent